import { EligibilityResult } from '../../../interfaces/api/EligibilityResult';
import type { PremiseDataDocument } from '../../../interfaces/containers/premises/PremiseData';
import { getPremiseEligibilityResult } from '../../../premises/data/attributes/eligibility/getPremiseEligibilityResult';

export function hasActiveElectric(masterData: PremiseDataDocument | undefined): masterData is PremiseDataDocument {
	// Check if the premise is active electric
	const eligibility = getPremiseEligibilityResult(masterData);
	return eligibility === EligibilityResult.ElectricActive;
}
